/* eslint-disable */
// Helper to get aria label for pagination items
export default function getAriaLabel(text, parent) {
  // If parent has 'aria-current="page"' attribute get text for current page
  if (parent.getAttribute('aria-current') === 'page') {
    return `Current page, page ${text}`;
  }

  // Return text for other pages
  return `Navigate to page ${text}`;
} 